import { useEffect, RefObject } from 'react';
import { Report } from '../../../lib/types';
import { FeedbackState } from '../types';

export const useScrollToBottom = (
    ref: RefObject<HTMLDivElement>,
    dependencies: {
        reports: Report[];
        feedback: FeedbackState;
    }
) => {
    useEffect(() => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    }, [ref, dependencies.reports, dependencies.feedback]);
};